import apiData from "lib/stores/apiData";
import api from "lib/api";
import currencyToString from "lib/helpers/currencyToString";
import productData from "lib/stores/productData";
import fetchCountries from "lib/api/fetchCountries";
import substrings from "lib/helpers/substrings";

const fetchContent = async () => {
  const geoCountryPromise = fetchCountries();
  const countryDataPromise = api.GetAllCountries();
  const importsPromise = api.GetImports();
  const metadataPromise = api.GetMetadata();
  const [geoData, countryData, importsData, metadataData] = await Promise.all([
    geoCountryPromise,
    countryDataPromise,
    importsPromise,
    metadataPromise
  ]);

  let countryDataKeys = [];

  countryDataKeys = countryData.countries.map(country => {
    return country.iso;
  });

  const keysToDelete = [];

  Object.keys(geoData.countries).forEach(key => {
    if (!countryDataKeys.includes(key)) {
      keysToDelete.push(key);
    }
  });

  const countriesToMerge = [];
  countryData.countries.forEach(country => {
    try {
      // if (country.name === "Trinidad and Tobago") {
      //   country.loc.bx0 = 61.9287;
      //   country.loc.bx1 = 60.522084;
      // }
      if (country?.download_urls) {
        geoData.countries[country.iso].download_urls = [
          "https://www.walkfree.org/wp-json/minderberg/gsi/v1/",
          "https://www.walkfree.org/wp-json/minderberg/gsi/v1/",
          "https://www.walkfree.org/wp-json/minderberg/gsi/v1/"
        ];
      }
      geoData.countries[country.iso].centroid = {
        cx: country.loc.cx,
        cy: country.loc.cy
      };
      geoData.countries[country.iso].bounds = {
        boundsOne: [country.loc.bx1, country.loc.by1],
        boundsTwo: [country.loc.bx0, country.loc.by0]
      };
      geoData.countries[country.iso].centroid = {
        cx: country.loc.cx,
        cy: country.loc.cy
      };
      geoData.countries[country.iso].bounds = {
        boundsOne: [country.loc.bx1, country.loc.by1],
        boundsTwo: [country.loc.bx0, country.loc.by0]
      };
      geoData.countries[country.iso]["2018"].gdp = country.data["2018"]?.gdp ?? 0;
      geoData.countries[country.iso]["2018"].govresponse = country.data["2018"]?.r ?? 0;
      geoData.countries[country.iso]["2018"].population = country.data["2018"]?.pop ?? 0;
      geoData.countries[country.iso]["2018"].prevalence = country.data["2018"]?.p ?? 0;
      geoData.countries[country.iso]["2018"].vulnerability = country.data["2018"]?.v ?? 0;
      geoData.countries[country.iso]["2023"].gdp = country.data["2023"]?.gdp ?? 0;
      geoData.countries[country.iso]["2023"].govresponse = country.data["2023"]?.r ?? 0;
      geoData.countries[country.iso]["2023"].population = country.data["2023"]?.pop ?? 0;
      geoData.countries[country.iso]["2023"].prevalence = country.data["2023"]?.p ?? 0;
      geoData.countries[country.iso]["2023"].vulnerability = country.data["2023"]?.v ?? 0;
      geoData.countries[country.iso].explore_country_content_url = country.data.explore_country_content_url;
      geoData.countries[country.iso].recommendations = [];
      geoData.countries[country.iso].documents = [];
      geoData.countries[country.iso].links = [];
      geoData.countries[country.iso].imports = [];
      geoData.countries[country.iso].region_id = country.region;
      geoData.countries[country.iso].documents_count = country.documents_count;
      geoData.countries[country.iso].fetched = false;
      geoData.countries[country.iso].fragments = substrings(country.name);
      geoData.countries[country.iso].g20 = country.g20;
    } catch (error) {
      countriesToMerge.push(country);
    }
  });

  countriesToMerge.forEach(country => {
    geoData.countries[country.iso] = {
      centroid: { cx: country.loc.cx, cy: country.loc.cy },
      fragments: substrings(country.name),
      bounds: {
        boundsOne: [country.loc.bx1, country.loc.by1],
        boundsTwo: [country.loc.bx0, country.loc.by0]
      },
      2018: {
        imports: [],
        gdp: country.data["2018"]?.gdp ?? 0,
        govresponse: country.data["2018"]?.r ?? 0,
        population: country.data["2018"]?.pop ?? 0,
        prevalence: country.data["2018"]?.p ?? 0,
        vulnerability: country.data["2018"]?.v ?? 0
      },
      2023: {
        imports: [],
        gdp: country.data["2023"]?.gdp ?? 0,
        govresponse: country.data["2023"]?.r ?? 0,
        population: country.data["2023"]?.pop ?? 0,
        prevalence: country.data["2023"]?.p ?? 0,
        vulnerability: country.data["2023"]?.v ?? 0
      },
      coordinates: [],
      documents: [],
      links: [],
      id: country.iso,
      g20: country.g20,
      iso: country.iso,
      name: country.name,
      download_urls: [
        "https://www.walkfree.org/wp-json/minderberg/gsi/v1/",
        "https://www.walkfree.org/wp-json/minderberg/gsi/v1/",
        "https://www.walkfree.org/wp-json/minderberg/gsi/v1/"
      ],
      recommendations: [],
      region: country.region,
      regionCode: "",
      subregion: "",
      region_id: country.region,
      documents_count: country.documents_count,
      fetched: false
    };
  });

  let countriesToDelete = [];

  Object.keys(geoData.countries).forEach(key => {
    if (!geoData.countries[key].region_id) {
      countriesToDelete.push(key);
    }
  });

  countriesToDelete.forEach(key => {
    delete geoData.countries[key];
  });

  importsData.forEach(importData => {
    geoData.countries[importData.country]["2018"].imports = [];
    geoData.countries[importData.country]["2023"].imports = [];
    geoData.countries[importData.country].imports = [];
    importData.products.forEach(product => {
      product.import_value = product.import_value * 1000;
      product.import_value_locale = currencyToString(product.import_value, {});
      const productData = metadataData.products.find(p => {
        return p.id === product.product_id;
      });
      const productValues = {
        importer: geoData.countries[importData.country].name,
        exporter: product.origin_country,
        product: productData.name,
        value: product.import_value,
        value_locale: product.import_value_locale,
        color: productData.color,
        icon: productData.icon,
        id: productData.id
      };
      geoData.countries[importData.country].imports.push(productValues);
    });
  });

  apiData.globals = geoData.globals;
  if (!geoData.globals.download_urls) {
    geoData.globals.download_urls = [
      "https://www.walkfree.org/wp-json/minderberg/gsi/v1/",
      "https://www.walkfree.org/wp-json/minderberg/gsi/v1/",
      "https://www.walkfree.org/wp-json/minderberg/gsi/v1/"
    ];
  }
  apiData.metadata = metadataData;
  apiData.products = new Map();
  metadataData.products.forEach(product => {
    apiData.products.set(product.name.toLowerCase(), product);
  });
  apiData.downloads = metadataData.downloads;
  apiData.worldwide = metadataData.global;
  apiData.globals.download_urls = [
    "https://www.walkfree.org/wp-json/minderberg/gsi/v1/",
    "https://www.walkfree.org/wp-json/minderberg/gsi/v1/",
    "https://www.walkfree.org/wp-json/minderberg/gsi/v1/"
  ];
  apiData.regions = metadataData.regions.map(region => {
    if (!region.download_url) {
      region.download_urls = [
        "https://www.walkfree.org/wp-json/minderberg/gsi/v1/",
        "https://www.walkfree.org/wp-json/minderberg/gsi/v1/",
        "https://www.walkfree.org/wp-json/minderberg/gsi/v1/"
      ];
    }
    return {
      ...region,
      "2023": {
        ...region["2023"],
        govresponse: region["2023"]?.gov_response ?? "-"
      }
    };
  });

  apiData.regions.forEach(region => {
    const links = apiData.metadata.regions.find(r => {
      return r.id === region.id;
    }).links;
    region.links = [...links];
  });

  apiData.countries = geoData.countries;
  apiData.countriesMap = new Map();
  Object.keys(apiData.countries).forEach(key => {
    apiData.countriesMap.set(key, apiData.countries[key]);
  });

  apiData.fetchingTopLevelData = false;
};

export default fetchContent;
